import { render, staticRenderFns } from "./ProductOverviewTab.vue?vue&type=template&id=63389b4b&scoped=true"
import script from "./ProductOverviewTab.vue?vue&type=script&lang=ts"
export * from "./ProductOverviewTab.vue?vue&type=script&lang=ts"
import style0 from "./ProductOverviewTab.vue?vue&type=style&index=0&id=63389b4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63389b4b",
  null
  
)

export default component.exports